module.exports = {
    "en": {
        "copy": {
            "noNotifications1": "No notifications right now. We'll let you know when something from your favourite programmes, artists and playlists is available for you.",
            "noNotifications2": "If your notifications are turned off, you can always turn them back on. Just go to settings.",
            "settings": "You can turn on and off any notifications you receive from iPlayer and Music. Turning notifications off will clear any you already have.",
            "upsell": {
                "title": "Never miss <br /> your favourites",
                "body": "Get notifications about your favourite programmes, music and more."
            },
            "onboardingInfo1": "This is the place to get notifications about your favourite programmes, music, radio and more.",
            "onboardingInfo2": "We'll give you notifications about anything already in your favourites, and anything new you add. You can manage your notifications any time in Settings.",
            "onboardingInfo3": "Notifications are based on things you&#146;ve added…",
            "onboardingInfo4": "… like TV and radio programmes, music artists and playlists.",
            "ok": "OK, I'm in",
            "showMeMore": "Show me more",
            "error": {
              "somethingWentWrong": "Sorry, something has gone wrong.",
              "hubDisplay": "There's been an error and your notifications <br />can't be displayed at the moment. Please try again later.",
              "hubUpdate": "Sorry, something has gone wrong.<br/>&nbsp;Your notifications could not be updated. Please try again later.",
              "settingsDisplay": "There's been an error and your notifications settings <br />cannot be retrieved. Please try again later.",
              "settingsUpdate" : "Sorry, something has gone wrong.<br/>&nbsp;Your settings could not be updated. Please try again later.",
              "onboarding": "There's been an error and we are unable to get you <br /> started with notifications. Please try again later."
            },
            "under13": {
                "moreInfo": "Find out more about child permissions",
                "parentId": {
                    "title": "Want to hear about new stuff first?",
                    "body": "To get notifications about stuff you love, you need to link BBC accounts with your parent or guardian and get their permission.",
                    "button": "OK, ask for permission"
                },
                "linkPending": {
                    "title": "You need permission from a parent or guardian to use notifications",
                    "body": "We've sent them an email that tells them what to do. Ask them to check their inbox and follow the steps. To send a new email, visit your BBC account settings."
                },
                "permissionNotifications": {
                    "title": "You need permission from a parent or guardian to use notifications",
                    "body": "They can give permission by visiting the Child Permissions section in their BBC account settings."
                },
                "done": "All done! You can now use your notifications."
            }
        }
    },
    'cy': {
        'Notifications': 'Hysbysiadau',
        "Notifications Settings": "Gosodiadau'r Hysbysiadau",
        "Settings": "Gosodiadau",
        "Here's a notification about a new clip from BBC Music.": "Dyma hysbysiad am glip newydd gan BBC Music.",
        "Here's a notification about a new episode in iPlayer.": "Dyma hysbysiad am bennod newydd yn iPlayer.",
        "Back": "Nôl",
        "day ago": "dydd yn ôl",
        "days ago": "o ddyddiau yn ôl",
        "hour ago": "awr yn ôl",
        "hours ago": "awr yn ôl",
        "minute ago": "munud yn ôl",
        "minutes ago": "o funudau yn ôl",
        "Yesterday": "Ddoe",
        "10 minutes ago": "10 munud yn ôl",
        "Just now": "Eiliad yn ôl",
        "{product} Notifications": "Gosodiadau {product}",
        "Sign in": "Mewngofnodi",
        "or": "neu",
        "Register": "Gofrestru",
        "Notifications are based on things you've added…": "Mae hysbysiadau wedi eu seilio ar bethau rydych chi wedi eu hychwanegu…",
        "… like TV and radio programmes, music artists and playlists.": "… fel rhaglenni teledu a radio, cerddoriaeth, artistiaid a rhestrau chwarae.",
        "You'll get notifications when there's something new…": "Byddwch yn cael eich hysbysu pan mae yna rywbeth newydd…",
        "… like an interview with a music artist you've added. Or an episode of a show you've added on iPlayer.": "… fel cyfweliad ag artist rydych chi wedi ei ychwanegu. Neu bennod o sioe rydych chi wedi ei ychwanegu ar iPlayer.",
        "You're in charge": "Yn eich dwylo chi",
        "Visit your Settings any time to manage your notifications.": "Ewch i'ch Gosodiadau unrhyw bryd i reoli eich hysbysiadau.",
        "Load More": "Llwytho mwy",
        "Close": "Cau",
        "Go to Next slide": "Mynd i'r sleid nesaf",
        "Go to Previous slide": "Mynd i'r sleid flaenorol",
        "Go to slide 1": "Mynd i sleid 1",
        "Go to slide 2": "Mynd i sleid 2",
        "Go to slide 3": "Mynd i sleid 3",
        "copy": {
            "noNotifications1": "Dim hysbysiadau ar hyn o bryd. Byddwn ni'n gadael i chi wybod pan mae rhywbeth gan eich hoff raglenni, artistiaid a rhestrau chwarae ar gael i chi.",
            "noNotifications2": "Os ydy'ch hysbysiadau wedi eu diffodd, gallwch eu troi nôl ymlaen. Ewch i'r gosodiadau.",
            "settings": "Gallwch droi hysbysiadau iPlayer a Music ymlaen neu eu diffodd. Bydd diffodd yr hysbysiadau yn cael gwared ar y rhai rydych chi wedi eu cael yn barod.",
            "upsell": {
                "title": "Peidiwch â methu eich ffefrynnau",
                "body": "Hysbysiadau am eich hoff rhaglenni, cerddoriaeth a mwy."
            },
            "onboardingInfo1": "Dyma'r lle i gael hysbysiadau am eich hoff raglenni, cerddoriaeth, radio a mwy. ",
            "onboardingInfo2": "Byddwn yn eich hysbysu am unrhywbeth sydd yn eich ffefrynnau yn barod, ac unrhywbeth rydych chi'n ei ychwanegu. Gallwch reoli eich hysbysiadau unrhyw bryd yn y Gosodiadau.",
            "onboardingInfo3": "Mae hysbysiadau wedi eu seilio ar bethau rydych chi wedi eu hychwanegu…",
            "onboardingInfo4": "… fel rhaglenni teledu a radio, cerddoriaeth, artistiaid a rhestrau chwarae.",
            "ok": "Iawn",
            "showMeMore": "Dangos mwy",
            "error": {
              "somethingWentWrong": "Mae rhywbeth wedi mynd o'i le.",
              "hubDisplay": "'Dyw hi ddim yn bosib dangos eich hysbysiadau ar hyn o bryd. Triwch eto nes ymlaen.",
              "hubUpdate": "'Dyw eich hysbysiadau ddim yn gallu cael eu diweddaru. Triwch eto nes ymlaen.",
              "settingsDisplay": "Mae yna broblem gyda'r gosodiadau ar hyn o bryd. Triwch eto nes ymlaen.",
              "settingsUpdate" : "'Dyw hi ddim yn bosib diweddaru eich gosodiadau. Triwch eto nes ymlaen.",
              "onboarding": "'Dyw hi ddim yn bosib dechrau arni ar hyn o bryd. Triwch eto nes ymlaen."
            },
            "under13": {
                "moreInfo": "Dysgu mwy am ganiatâd i blant",
                "parentId": {
                    "title": "Eisiau clywed am bethau newydd gyntaf?",
                    "body": "Er mwyn derbyn hysbysiadau am dy hoff bethau, rhaid i ti gysylltu cyfrifon BBC gyda dy riant neu warchodwr er mwyn cael eu caniatâd.",
                    "button": "Iawn, gofyn am ganiatâd"
                },
                "linkPending": {
                    "title": "Rwyt ti angen caniatâd rhiant neu warchodwr i ddefnyddio hysbysiadau",
                    "body": "Rydyn ni wedi anfon e-bost atyn nhw sy’n egluro beth i’w wneud. Maen nhw angen edrych yn eu mewnflwch a dilyn y cyfarwyddiadau. Er mwyn cael e-bost newydd, cer i osodiadau dy gyfrif BBC."
                },
                "permissionNotifications": {
                    "title": "Rwyt ti angen caniatâd rhiant neu warchodwr i ddefnyddio hysbysiadau",
                    "body": "Gallan nhw roi caniatâd drwy fynd i adran Caniatâd i Blant yng ngosodiadau eu cyfrif BBC."
                },
                "done": "Barod! Nawr galli di ddefnyddio dy hysbysiadau."
            }
        }
    },
    "gd": {
        "Notifications": "Fiosan",
        "Notifications Settings": "Seataidhean Fiosa",
        "Settings": "Seataidhean",
        "Here's a notification about a new clip from BBC Music.": "Seo fios mu chriomag ùr bho BBC Music.",
        "Here's a notification about a new episode in iPlayer.": "Seo fios mu phrògram ùr ann an iPlayer.",
        "Back": "Air ais",
        "day ago": "latha air ais",
        "days ago": "làithean air ais",
        "hour ago": "uair air ais",
        "hours ago": "uairean air ais",
        "minute ago": "mhionaid air ais",
        "minutes ago": "mionaidean air ais",
        "Yesterday": "An-dè",
        "10 minutes ago": "10 mionaidean air ais",
        "Just now": "An-dràsta",
        "{product} Notifications": "Fiosan {product}",
        "Sign in": "Log a-steach",
        "or": "no",
        "Register": "Clàraich",
        "Notifications are based on things you've added…": "Tha fiosan stèidhichte air rudan a chur thu ris...",
        "… like TV and radio programmes, music artists and playlists.": "… mar phrògraman Tbh agus rèidio, luchd ciùil agus clàran-ciùil.",
        "You'll get notifications when there's something new…": "Gheibh thu fiosan nuair a tha rudan ùra ann…",
        "… like an interview with a music artist you've added. Or an episode of a show you've added on iPlayer.": "… mar agallamh le luchd ciùil a chur thu ris. No prògram a chur thu ris ann an iPlayer.",
        "You're in charge": "'S tusa a tha os cionn chùisean!",
        "Visit your Settings any time to manage your notifications.": "Thèid gu Seataidhean airson rian a chumail air d' fhiosan",
        "Load More": "Faic tuilleadh",
        "Close": "Dùin",
        "Go to Next slide": "An ath slaighd",
        "Go to Previous slide": "An slaighd roimhe",
        "Go to slide 1": "Rach gu slaighd 1",
        "Go to slide 2": "Rach gu slaighd 2",
        "Go to slide 3": "Rach gu slaighd 3",
        "copy": {
            "noNotifications1": "Chan eil fiosan ann an-dràsta. Leigidh sinn fios nuair a bhios rudeigin ann bho na prògraman, luchd ciùil is clàran-ciùil as fheàrr leat.",
            "noNotifications2": "Ma tha d’ fhiosan air an cur dheth, faodaidh tu an cur air a-rithist le bhith dol gu seataidhean.",
            "settings": "Faodar brathan a tha thu a' faighinn bho iPlayer agus Music a chur air is dheth. Thèid an fheadhainn a th' agad mar-thà a dhubhadh às le bhith gan cuir dheth.",
            "upsell": {
                "title": "Na caill na rudan as fheàrr leat",
                "body": "Faigh fiosan mu na prògraman 's an ceòl as fheàrr leat agus gu leòr eile."
            },
            "onboardingInfo1": "Seo far am faighear fiosan mu na prògraman 's an ceòl as fheàrr leat agus gu leòr eile.",
            "onboardingInfo2": "Cuiridh sinn fiosan thugad mu na rudan a tha nad roghainnean agus rud sam bith eile a chuireas tu ris. Faodaidh tu rian a chumail air iad seo ann an Seataidhean.",
            "onboardingInfo3": "Tha fiosan stèidhichte air rudan a chur thu ris...",
            "onboardingInfo4": "… mar phrògraman Tbh agus rèidio, luchd ciùil agus clàran-ciùil.",
            "ok": "Ceart",
            "showMeMore": "Seall tuilleadh",
            "error": {
              "somethingWentWrong": "Duilich, tha rudeigin air a dhol ceàrr.",
              "hubDisplay": "Chaidh rudeigin ceàrr is chan urrainnear d’ fhiosan a shealltainn an-dràsta. Feuch a-rithist.",
              "hubUpdate": "Duilich, tha rudeigin air a dhol ceàrr. Cha b’ urrainnear d' fhiosan ùrachadh. Feuch a-rithist.",
              "settingsDisplay": "Chaidh rudeigin ceàrr is chan fhaighear do sheataidhean fiosa. Feuch a-rithist.",
              "settingsUpdate" : "Duilich, tha rudeigin air a dhol ceàrr. Cha b’ urrainnear do sheataidhean ùrachadh. Feuch a-rithist.",
              "onboarding": "Chaidh rudeigin ceàrr is chan fhaigh sinn air d’ fhiosan a chur an sàs. Feuch a-rithist."
            },
            "under13": {
                "moreInfo": "Faigh a-mach tuilleadh mu cheadan cloinne",
                "parentId": {
                    "title": "Airson cluinntinn mu rudan ùra an toiseach?",
                    "body": "Feumaidh tu cead fhaighinn bho do phàrant no do neach-cùraim agus do chunntas BBC a cheangal ris an fhear acasan airson fiosan fhaighinn mu na rudan a tha a’ còrdadh riut.",
                    "button": "Ceart, iarr cead"
                },
                "linkPending": {
                    "title": "Feumar cead fhaighinn bho phàrant no neach-cùraim airson fiosan a chleachdadh",
                    "body": "Tha sinn air post-d a chur thuca le stiùireadh. Iarr orra sùil a thoirt air na puist-d aca agus na ceumannan a' leantainn. Tadhal air seataidhean cunntais a' BhBC airson post-d a chur air falbh."
                },
                "permissionNotifications": {
                    "title": "Feumar cead fhaighinn bho phàrant no neach-cùraim airson fiosan a chleachdadh",
                    "body": "Faodaidh iadsan cead a thoirt le bhith tadhal air Ceadan Chloinne ann an seataidhean cunntais a' BhBC."
                },
                "done": "Dèanta! Faodaidh tu na fiosan agad a chleachdadh."
            }
        }
    },
    "ga": {
      "Notifications": "Fógraí",
      "Notifications Settings": "Socruithe na bhFógraí",
      "Settings": "Socruithe",
      "Here's a notification about a new clip from BBC Music.": "Seo fógra faoi ghearrthóg úr ó BBC Music.",
      "Here's a notification about a new episode in iPlayer.": "Seo fógra faoi eagrán úr ar iPlayer.",
      "Back": "Siar",
      "day ago": "lá ó shin",
      "days ago": "lá ó shin",
      "hour ago": "uair ó shin",
      "hours ago": "uair ó shin",
      "minute ago": "nóiméad ó shin",
      "minutes ago": "nóiméad ó shin",
      "Yesterday": "Inné",
      "10 minutes ago": "10 mbomaite ó shin",
      "Just now": "Díreach ansin",
      "{product} Notifications": "Fógraí {product}",
      "Sign in": "Sínigh isteach",
      "or": "nó",
      "Register": "Cláraigh",
      "Notifications are based on things you've added…": "Tá fógraí bunaithe ar rudaí a chuir tú leis…",
      "… like TV and radio programmes, music artists and playlists.": "… mar shampla, cláir TV, raidió, ceoltóirí agus seinnliostaí.",
      "You'll get notifications when there's something new…": "Gheobhaidh tú fógraí nuair atá rudaí úra ann.",
      "… like an interview with a music artist you've added. Or an episode of a show you've added on iPlayer.": "… ar nós agallaimh le ceoltóir a chuir tú leis, nó eagrán de chlár a chuir tú le iPlayer.",
      "You're in charge": "Tá tú i gceannas!",
      "Visit your Settings any time to manage your notifications.": "Tabhair cuairt ar do chuid Socruithe le go dtig leat smacht a choinneáil orthu.",
      "Load More": "Lódáil tuilleadh",
      "Close": "Druid",
      "Go to Next slide": "Téigh go céad sleamhnán eile",
      "Go to Previous slide": "Téigh go sleamhnán roimhe",
      "Go to slide 1": "Téigh go sleamhnán 1",
      "Go to slide 2": "Téigh go sleamhnán 2",
      "Go to slide 3": "Téigh go sleamhnán 3",
      "copy": {
        "noNotifications1": "Níl fógraí ann faoi láthair. Beidh muid i dteagmháil leat má bhíonn rud éigin ar fáil a bhaineann leis na cláir, na ceoltóirí nó na seinnliostaí is ansa leat.",
        "noNotifications2": "Má tá do chuid fógraí múchta, thig leat iad a chur air arís. Téigh go socruithe.",
          "settings": "Thig leat fógraí ó iPlayer agus Music a chur air nó as. Glanfaidh tú na fógraí atá agat cheana féin má mhúchann tú iad.",
          "upsell": {
              "title": "Ná caill do chianáin riamh",
              "body": "Aimsigh fógraí faoi do chianáin, do cheol agus níos mó."
          },
          "onboardingInfo1": "Is anseo a dtig leat fógraí a aimsiú faoi na cláir, faoin cheol, faoin raidió is ansa leat agus níos mó.",
          "onboardingInfo2": "Cuirfidh muid fógraí ar fáil duit faoi rud ar bith atá i do chianáin cheana féin agus faoi rud ar bith úr a chuireann tú leo. Thig leat smacht a bheith agat ar do chuid fógraí am ar bith in Socruithe.",
          "onboardingInfo3": "Tá fógraí bunaithe ar rudaí a chuir tú leis…",
          "onboardingInfo4": "… mar shampla, cláir TV, raidió, ceoltóirí agus seinnliostaí.",
          "ok": "Ceart go leor",
          "showMeMore": "Taispeáin a thuilleadh",
          "error": {
            "somethingWentWrong": "Tá brón orainn, tá rud éigin cearr.",
            "hubDisplay": "Tá rud éigin cearr agus ní féidir do chuid fógraí a fheiceáil faoi láthair. Triail arís níos moille, le do thoil.",
            "hubUpdate": "Tá brón orainn, tá rud éigin cearr. Ní féidir do chuid fógraí a uasdátú. Triail arís níos moille, le do thoil.",
            "settingsDisplay": "Tá fadhb le socruithe na bhfógraí s'agat agus níl fáil orthu. Triail arís níos moille, le do thoil.",
            "settingsUpdate" : "Tá brón orainn, tá rud éigin cearr. Ní féidir do chuid fógraí a uasdátú. Triail arís níos moille, le do thoil.",
            "onboarding": "Tá fadhb éigin ann agus ní féidir do chuid fógraí a chur sa tsiúl. Triail arís níos moille, le do thoil."
          },
          "under13": {
              "moreInfo": "Tuilleadh eolais ar cheadanna páistí",
              "parentId": {
                  "title": "Ar mhaith leat bheith ar an eolas faoin stuif úr ar dtús?",
                  "body": "Le fógraí a fháil ar an stuif is ansa leat, beidh ort cuntais BBC a nascadh le do thuismitheoir nó le do chaomhnóir agus a c(h)ead a fháil.",
                  "button": "Maith go leor, iarr cead."
              },
              "linkPending": {
                  "title": "Tá cead tuismitheora nó caomhnóra de dhíth ort le fógraí a úsáid",
                  "body": "Sheol muid ríomhphost chucu a insíonn dóibh cad é atá le déanamh. Iarr orthu a mbosca isteach a sheiceáil agus na céimeanna a leanúint. Le ríomhphost úr a sheoladh, tabhair cuairt ar shocruithe do chuntais BBC."
              },
              "permissionNotifications": {
                  "title": "Tá cead tuismitheora nó caomhnóra de dhíth ort le fógraí a úsáid",
                  "body": "Thig leo cead a thabhairt ach dul chuig Ceadanna Páistí i socruithe a c(h)untais BBC."
              },
              "done": "Déanta! Thig leat d’fhógraí a úsáid anois."
          }
      }
    }
};



/** WEBPACK FOOTER **
 ** ./assets/js/i18n.js
 **/